import ActionTypes from './../Action/ActionTypes';
import moment from 'moment';
import { DdLogs } from '../src/logging/datadog';
export default function TeamShiftLogsReducer(
  preState = { shiftLogs: [], isLoading: false },
  action,
) {
  switch (action.type) {
    case ActionTypes.LOADINGINPROGRESS: {
      DdLogs.info('loading teamshift log reducer');
      DdLogs.info('action.loading: ' + action.isLoading);
      return {
        ...preState,
        isLoading: action.isLoading,
      };
    }
    case ActionTypes.GET_TEAMSHIFTLOGS: {
      DdLogs.info('receive teamshift log data: ' + new Date().getSeconds());

      let newDataOrder = action.payload
        .map((val) => {
          const mapped = {
            ...val,
            createTime: new Date(val.createTime).getTime(),
          };

          if (preState.shiftLogs.length > 0) {
            let pre = preState.shiftLogs.find((u) => u.shiftSummaryID == val.shiftSummaryID);
            if (pre && pre.status == val.status) {
              if (moment(val.submitTime).isSameOrBefore(pre.submitTime)) {
                mapped.fileContent = pre.fileContent;
              }
            }
          }
          return mapped;
        })
        .sort((a, b) => b.createTime - a.createTime);
      return {
        shiftLogs: [...newDataOrder],
        isLoading: false,
      };
    }
    case ActionTypes.UPDATE_TEAM_SHIFTLOG: {
      // action.payload[0].shiftSummaryID
      let currentShiftLog = action.payload;
      let previousShiftLogs = [...preState.shiftLogs];
      let preShiftLog = previousShiftLogs.find(
        (u) => u.shiftSummaryID == currentShiftLog.shiftSummaryID,
      );
      let combinedShiftLog = {};
      switch (currentShiftLog.fileStatus) {
        //if logs in inprogress state. filecontent will be empty
        case 'NoFile':
          {
            combinedShiftLog = {
              ...preShiftLog,
              ...currentShiftLog,
            };
          }
          break;
        // if fileDownload is false
        case 'NoDownload':
          {
            combinedShiftLog = {
              ...preShiftLog,
              ...currentShiftLog,
            };
          }
          break;
        case 'NoUpdate':
          let fileContent = preShiftLog.fileContent;
          combinedShiftLog = {
            ...preShiftLog,
            ...currentShiftLog,
            fileContent,
          };
          break;
        case 'Download':
          DdLogs.info('case Download: ');
          combinedShiftLog = {
            ...preShiftLog,
            ...currentShiftLog,
            lastUpdate: moment.utc(Date.now()).format(),
          };
          break;
        default:
          combinedShiftLog = {
            ...currentShiftLog,
          };
      }
      let ind = previousShiftLogs.findIndex(
        (u) => u.shiftSummaryID == currentShiftLog.shiftSummaryID,
      );
      ind >= 0 && previousShiftLogs.splice(ind, 1, combinedShiftLog);
      return {
        ...preState,
        shiftLogs: previousShiftLogs,
      };
    }
    case ActionTypes.ADD_TEAMSHIFTLOG: {
      DdLogs.info('before add total: ' + preState.shiftLogs.length);
      const shiftLogs = [...preState.shiftLogs, action.payload];
      DdLogs.info('after added total: ' + shiftLogs.length);

      return {
        ...preState,
        shiftLogs,
      };
    }

    default:
      return preState;
  }
}